import React from "react";
import { MdOutlineClose } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { decrementQuantity, deleteItem, incrementQuantity, resetCart } from "../redux/bazarSlice";
import { toast ,ToastContainer} from "react-toastify";
import { Link } from "react-router-dom";
import { HiOutlineArrowLeft } from "react-icons/hi";

const Cartitem=(props)=>{
    const settotalAmt=props.settotalAmt;
    const dispatch=useDispatch();
    const productData=useSelector((state)=>state.bazar.productData);
    return <div className="w-2/3 pr-10">
        <div className="w=full">
        <h2 className="font-titleFont text-2xl">Shopping Cart</h2>
        </div>
        <div>
            {
                productData.map((item)=>(
                    <div key={item._id} className="flex items-center justify-between gap-6 mt-6">
                        <div className="flex items-center gap-2">
                            <MdOutlineClose className="text-xl text-gray-600 hover:text-red-600 cursor-pointer duration-300" onClick={()=>dispatch(deleteItem(item._id))&toast.error(`${item._id} is removed`)}/>
                            <img className="w-32 h-32 object-cover" src={item.image} alt="productImg"></img>

                        </div>
                        <h2 className="w-52 font-bold">{item._id}</h2>
                        <p className="w-10">${item.price}</p>
                        
           <div className="flex gap-6 items-center">
           <div className=" w-52 px-4 py-2 flex justify-between border">
           <p className="text-sm">Quatity</p>
                        <div className="flex items-center gap-4 text-sm font-semibold bg">
           <button onClick={()=>dispatch(decrementQuantity({_id:item._id}))} className="border  h-5 font-normal text-lg flex items-center justify-center px-2 hover:bg-gray-800 hover:text-white cursor-pointer duration-300 position-fixed">-</button>
           <span>{item.quantity}</span>
           <button onClick={()=>dispatch(incrementQuantity({_id:item._id}))}className="border h-5 font-normal text-lg flex items-center justify-center px-2 hover:bg-gray-800 hover:text-white cursor-pointer duration-300 active:bg-black">+</button>
           </div>
                    </div>
                    <p>$ {item.quantity*item.price}</p>
                    </div>
                    </div>

                ))
            }
        </div>
        {
            productData.length>0 &&(
        <div className="w-80 py-2 my-4  flex item-center ">
          
             <button onClick={()=>dispatch(resetCart())&toast.error("All items removed")&settotalAmt(0)}className=" w-40 bg-orange-500 px-3 py-1 text-white text-bold rounded-md hover:text-black hover:bg-blue-400 duration-300">RESET</button>
             </div>
        )}

       
        <Link to="/">
        <div className="w-40 text-center text-gray-400 flex gap-2  justify-center items-center" > <HiOutlineArrowLeft/>Go to Shopping</div>
        </Link>
        <ToastContainer
     position="top-left"
     autoClose={2000}
     hideProgressBar={false}
     newestOnTop={false}
     closeOnClick
     rtl={false}
     pauseOnFocusLoss
     draggable
     pauseOnHover
     theme="dark"
    >
    </ToastContainer>
        </div>
}
export default Cartitem;